
export const humanizeDate = (utcDateStr: string) => {
    const localDate = new Date(utcDateStr);
    const day = localDate.getUTCDate().toString().padStart(2, '0');
    const month = (localDate.getUTCMonth() + 1).toString().padStart(2, '0'); // getUTCMonth() retorna un valor de 0 a 11
    const year = localDate.getUTCFullYear();

    const hours = localDate.getUTCHours().toString().padStart(2, '0');
    const minutes = localDate.getUTCMinutes().toString().padStart(2, '0');
    const seconds = localDate.getUTCSeconds().toString().padStart(2, '0');

    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
};


export const humanizeDateAndSetArgTimezone = (utcDateStr: string) => {
    const localDate = new Date(utcDateStr);
    const options: Intl.DateTimeFormatOptions = {
        timeZone: 'America/Argentina/Buenos_Aires',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    };
    const formattedDate = localDate.toLocaleString('es-AR', options);
    const [datePart, timePart] = formattedDate.split(', ');
    const [day, month, year] = datePart.split('/');
    const [hours, minutes, seconds] = timePart.split(':');

    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
};